// Use this method to get a nested attribute value from a backbone model
// eg: standard backbone functionality allows expressions like:
// model.get('first_level')['second_level']['third_level'];
// and this method can be used like:
// getNestedAttribute(model, 'first_level.second_level.third_level');
export default function getNestedAttribute(model, attrKey) {
  var attrNameArr = attrKey.split(".");
  var result = model.get(attrNameArr[0]);
  attrNameArr.shift();

  if (result && attrNameArr.length > 0) {
    Array.prototype.forEach.call(attrNameArr, function(nestedKey) {
      result = result[nestedKey];
      if (typeof result === 'undefined') {
        result = null;
        return false;
      }
    });
  }

  return result;
}
